/* Custom element for the "Read More" button
  * This element is used to create a button that will show/hide a section of text
*/

if (!customElements.get('read-more')) {
	customElements.define('read-more', class extends HTMLElement {
		constructor() {
			super();
			this.settings = {
				maxHeight: window.innerWidth < 500 ? 190 : (window.innerWidth < 1200 ? 178 : 155)
			}
		}

		connectedCallback() {
			// Check if the content overflows the max height
			if (this.scrollHeight <= this.settings.maxHeight) return;
			this.classList.add('read-more--init');
			this.button.addEventListener('click', this.toggle.bind(this));
		}

		toggle() {
			this.classList.toggle('read-more--open');
			this.button.setAttribute('aria-expanded', this.classList.contains('read-more--open'));
			let expanded = this.button.getAttribute('aria-expanded') === "true";
			this.button.innerHTML = expanded ? "En savoir moins" : "En savoir plus";
		}

		get button() {
			return this.querySelector('button.read-more__button');
		}
	});
}